export default __webpack_public_path__ + "6f3617a0f639a00b1ca67bce39489682.svg";